<template >
  <div :class="{ conditionalClass: visualInnerVersion }">
    <main class="visual">
        <Header :isMobileHorizontal="isMobileHorizontal" />
        <router-view :isMobileHorizontal="isMobileHorizontal"/>
        <Preloader />
        <Tooltip />
        <Panel :isMobileHorizontal="isMobileHorizontal" />
    </main>
  </div>
</template>

<style lang='scss'>
    @import "./App.scss";

    .conditionalClass {
      @import './innerVisual.scss';
    }
</style>

<script>
import Header from './components/Header/Header.vue';
import {mapGetters} from 'vuex';
import Panel from './components/Panel/Panel.vue';
import Preloader from './components/Preloader/Preloader.vue';
import Tooltip from './components/Tooltip/Tooltip.vue';
import {Utils} from 'common/scripts/utils';

export default {
    components: {
        Header,
        Panel,
        Preloader,
        Tooltip
    },

    computed: {
        ...mapGetters({
            visualInnerVersion: 'GET_VISUAL_VERSION'
        })
    },

    data() {
        return {
            doc               : document.documentElement,
            appHeight         : 0,
            isMobileHorizontal: false
        };
    },

    mounted() {
        this.setAppHeight();
        this.setIsMobileHorizontal();

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, this.setAppHeight.bind(this));
        });
    },

    beforeDestroy() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.removeEventListener(event, this.setAppHeight, false);
        });
    },

    methods: {
        setAppHeight() {
            this.appHeight = `${window.innerHeight * 0.01}px`;
            this.doc.style.setProperty('--vh', this.appHeight);

            this.setIsMobileHorizontal();
        },

        setIsMobileHorizontal() {
            this.isMobileHorizontal = Utils.isMobile() && Utils.getWindowWidth() >= Utils.getWindowHeight();
        }
    }
};
</script>
